import { ListParams } from '../../types/store'

const initialState: ListParams = {
  pageSize: 50,
  page: 1,
}

export const titechList = (
  state = initialState,
  action: {type: string, [k: string]: any}
) => {
  switch (action.type) {
    case 'TITEC_LIST_APPLY_PARAMS':
      return {
        ...state,
        ...action.params,
      }
    default:
      return state
  }
}
